import React, { useCallback, useMemo, useRef } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import ClientListComponent from '@/components/CommercialPage/ClientList/ClientListComponent';
import { useClients } from '@/hooks/useClients';

const ClientListContainer = () => {
  const query = useSelector(state => state.filter.query);
  const intl = useIntl();

  const scrollParentRef = useRef(null);

  const { useInfiniteClientsList } = useClients();
  const { data, fetchNextPage, hasNextPage, isLoading, isFetchingNextPage, isError } = useInfiniteClientsList({
    text: query?.text,
    status: 'enabled', // Matching previous logic or reference
  });

  const clients = useMemo(() => {
    if (!data) return [];
    return data.pages.flat().map(item => ({ data: item }));
  }, [data]);

  const loadMore = useCallback(() => {
    if (hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  }, [fetchNextPage, hasNextPage, isFetchingNextPage]);

  if (isError) {
    // We could show a toast here via useEffect or just render an error state
  }

  return (
    <ClientListComponent
      busy={isLoading}
      clients={clients}
      loadMore={loadMore}
      hasMore={hasNextPage}
      scrollParentRef={scrollParentRef}
    />
  );
};

export default ClientListContainer;
